export default function WaveDivider({ flip = false, color = "#BAE6FD", className = "" }) {
  return (
    <div className={`w-full leading-none ${className}`} aria-hidden="true">
      <svg
        viewBox="0 0 1440 80"
        preserveAspectRatio="none"
        className="w-full h-12 md:h-20 block"
        style={{ transform: flip ? "scaleY(-1)" : "none" }}
      >
        <path
          d="M0,32 C320,80 720,0 1440,48 L1440,80 L0,80 Z"
          fill={color}
        />
      </svg>
    </div>
  );
}
